export function requireInteger(event) {
    if (event.which < 48 || event.which > 57)
    {
        event.preventDefault();
    }
}

export function requireAlphaNumeric(event) {
    const regex = /^[A-Za-z0-9]+$/;
    const isAlphaNumeric = regex.test(event.key);

    if (!isAlphaNumeric) {
        event.preventDefault();
    }
}